module.exports = __webpack_public_path__ + "img/services_left_bar.dc0e034f.jpg";